export default "__VITE_ASSET__Sa5Y17CV__";